@if (soldTo || stepNo) {
  <div class="contract-step-bar">
    @if (!isLoading) {
      @if (stepNo === 1 && functionalLocationCount === 0) {
        @if (functionalLocation) {
          <div class="contract-product">
            <div class="image__thumbnail">
              <img alt="{{ functionalLocation.nameEnUs }}" [src]="functionalLocation.externalUrlSmall"/>
            </div>
            <div class="contract-product-description desktop">
              <p class="contract-product-description__info font-weight-bold">{{ functionalLocation.nameEnUs }}</p>
              <p class="contract-product-description__info">{{ 'contract-steps-bar.fl' | translate }} {{ serviceParams['fl-number'] }}</p>
            </div>
            <div class="contract-product-description mobile">
              <p class="contract-product-description__info">{{ 'contract-steps-bar.quote-id' | translate }}</p>
              <p class="contract-product-description__info font-weight-bold">{{ cart?.id }}</p>
              <p class="contract-product-description__info nickname" [attr.data-test]="'button-addNickName'"
                (click)="showAddNicknameModal = true">
              {{ hasNickname ? nickname : 'contract-steps-bar.add-nickname' | translate }}</p>
              <p class="contract-product-description__info">{{ 'contract-steps-bar.fl' | translate }} {{ serviceParams['fl-number'] }}</p>
              <p class="contract-product-description__info">{{ functionalLocation.nameEnUs }}</p>
            </div>
          </div>
        }
      }
      @if (stepNo === 2 || isConfigSummary || (stepNo === 1 && functionalLocationCount > 0)) {
        @if (functionalLocation && cart) {
          <div class="contract-product">
            <div class="image__thumbnail">
              <img alt="{{ functionalLocation.nameEnUs }}" [src]="functionalLocation.externalUrlSmall"/>
            </div>
            <div class="contract-product-description">
              <p class="contract-product-description__info font-weight-bold">{{ cart.id }}</p>
              <p class="contract-product-description__info nickname" (click)="showAddNicknameModal = true">
              {{ hasNickname ? nickname : 'contract-steps-bar.add-nickname' | translate }}</p>
              <p class="contract-product-description__info">{{ 'contract-steps-bar.fl' | translate }} {{ serviceParams['fl-number'] }}</p>
              <p class="contract-product-description__info">{{ functionalLocation.nameEnUs }}</p>
            </div>
          </div>
        }
      }
      @if (isQuoteSummary || soldTo) {
        @if (itemsInCart && cart) {
          <div class="contract-product">
            <div class="image__thumbnail">
              <img alt="{{ cartItemAlt }}" [src]="cartItemImage"/>
            </div>
            <div class="contract-product-description">
              <p class="contract-product-description__info font-weight-bold">{{ cart.id }}</p>
              <p class="contract-product-description__info nickname" (click)="showAddNicknameModal = true">
              {{ hasNickname ? nickname : 'contract-steps-bar.add-nickname' | translate }}</p>
              <p class="contract-product-description__info">{{ 'mini-cart.equType' | translate:{count: equipmentTypesCount} }}</p>
              <p class="contract-product-description__info">{{ 'mini-cart.fls' | translate:{count: functionalLocationCount} }}</p>
            </div>
          </div>
        }
      }
    } @else {
      <div class="contract-product">
        <div class="image__thumbnail stripe">
        </div>
        <div class="contract-product-description__stripe">
          <p class="stripe"></p>
          <p class="stripe"></p>
          <p class="stripe"></p>
          <p class="stripe"></p>
        </div>
      </div>
    }
    @if (stepNo) {
      <div class="steps-bar">
        @for (step of steps; track step) {
          <div
            class="steps-bar__item" [attr.data-test]="'stepBarItem'"
            [ngClass]="{'current': step.index === stepNo, 'completed': step.index < stepNo}">
            <div class="steps-bar__number" [attr.data-test]="'desc-stepBarNumber'"><span>{{ step.index }}</span></div>
            <div class="steps-bar__title" [attr.data-test]="'desc-stepBarTitle'">{{ step.title | translate }}</div>
          </div>
        }
      </div>
    }
  </div>
}


@if (showAddNicknameModal) {
  <app-modal-add-cart-name
    [cartId]="cart.id"
    [hasNickname]="hasNickname"
    [newNameChange]="currentCartName$"
    [showAddNicknameModal]="showAddNicknameModal"
    (closeModal)="showAddNicknameModal = false">
  </app-modal-add-cart-name>
}
